(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avenor-home-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.av-mobile-menu nav a');
  if (link) link.closest('details').removeAttribute('open');
});

function initAvenorAnnouncements(scope=document){
scope.querySelectorAll('[data-av-announcement]').forEach(root=>{
if(root.dataset.avaReady)return;root.dataset.avaReady='true';
const slides=Array.from(root.querySelectorAll('[data-ava-message]'));let index=0,timer;
const schedule=()=>{clearTimeout(timer);if(!document.hidden)timer=setTimeout(()=>{index=(index+1)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==index;slide.classList.toggle('ava-enter',i===index);});schedule();},5000);};
document.addEventListener('visibilitychange',schedule);schedule();
});}
initAvenorAnnouncements();document.addEventListener('shopify:section:load',event=>initAvenorAnnouncements(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avenor-home"] && !Shopify.designMode) return;
  try {
    
const avenorReveal = () => { if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; const observer = new IntersectionObserver((entries) => { entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('av-visible'); observer.unobserve(entry.target); } }); }, {threshold:0.08}); document.querySelectorAll('.av-card,.av-section-head,.av-feature,.av-scene-content').forEach(el => {el.classList.add('av-reveal'); observer.observe(el);}); }; avenorReveal(); document.addEventListener('shopify:section:load',avenorReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avenor-signature-product"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.asp').forEach(root=>{root.querySelectorAll('[data-purchase-link]').forEach(link=>{link.setAttribute('href','#asp-purchase');});const gallery=root.querySelector('[data-gallery]');if(gallery){const slides=[...gallery.querySelectorAll('[data-slide]')],thumbs=[...gallery.querySelectorAll('[data-thumb]')];let current=slides.findIndex(el=>!el.hidden);function show(index){current=(index+slides.length)%slides.length;slides.forEach((el,i)=>el.hidden=i!==current);thumbs.forEach((el,i)=>el.setAttribute('aria-pressed',String(i===current)));root.querySelectorAll('[data-mood]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.mood)===current)));gallery.querySelector('[data-counter]').textContent=(current+1)+' / '+slides.length;}thumbs.forEach((el,i)=>el.addEventListener('click',()=>show(i)));gallery.querySelectorAll('[data-step]').forEach(el=>el.addEventListener('click',()=>show(current+Number(el.dataset.step))));}root.querySelectorAll('[data-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name="quantity"]');input.value=Math.max(1,Math.min(99,Number(input.value||1)+Number(button.dataset.quantity)));input.dispatchEvent(new Event('change',{bubbles:true}));}));});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avenor-store-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ax-catalog]').forEach(root => {
  const buttons = root.querySelectorAll('[data-ax-filter]');
  buttons.forEach(button => { const category = button.dataset.axFilter; button.querySelector('.ax-filter-count').textContent = Array.from(root.querySelectorAll('[data-ax-category]')).filter(card => category === 'all' || card.dataset.axCategory === category).length; });
  buttons.forEach(button => button.addEventListener('click', () => {
    const category = button.dataset.axFilter;
    let count = 0;
    root.querySelectorAll('[data-ax-category]').forEach(card => {
      const show = category === 'all' || card.dataset.axCategory === category;
      card.hidden = !show;
      if (show) count++;
    });
    buttons.forEach(item => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); });
    root.querySelector('[data-ax-count]').textContent = count;
    root.querySelector('[data-ax-empty]').hidden = count !== 0;
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
